<div class="section">
  <div class="meta-header">
    <h3>Attachments</h3>
    @if (canEdit) {
      <span class="action-button">
        <button mat-button (click)="openFileUploadDialog()">
          <mat-icon class="material-symbols-outlined">add</mat-icon>Add
        </button>
      </span>
    }
  </div>
  <div class="content-container">
    <div
      #fileDropZone
      class="file-drop-zone"
      [class.is-hovering]="isHovering && canEdit"
      [class.is-disabled]="!canEdit"
    >
      <div *ngIf="isHovering && canEdit" class="drop-message">
        <mat-icon class="material-symbols-outlined">insert_drive_file</mat-icon>
        Drop files to upload
      </div>
      @if (dataSource.data.length > 0) {
        <table mat-table [dataSource]="dataSource" matSort class="mat-mdc-table rde-table">
          <ng-container matColumnDef="file_name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Filename</th>
            <td mat-cell *matCellDef="let file">
              <span class="cell-bold">{{ file.file_name }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="size">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Size</th>
            <td mat-cell *matCellDef="let file">{{ formatFileSize(file.size) }}</td>
          </ng-container>

          <ng-container matColumnDef="time_updated">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Date Modified</th>
            <td mat-cell *matCellDef="let file">
              <span class="cell-date">{{ formatDateTime(file.time_updated) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="download_action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let file">
              <button matIconButton (click)="downloadFile(file)" [attr.aria-label]="'Download file ' + file.file_name">
                <mat-icon aria-hidden="true" class="material-symbols-outlined">download</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="delete_action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let file">
              <button
                matIconButton
                color="warn"
                (click)="deleteAttachment(file)"
                *ngIf="canEdit"
                matTooltip="Delete File"
                [attr.aria-label]="'Delete file ' + file.file_name"
              >
                <mat-icon aria-hidden="true" class="material-symbols-outlined">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      } @else {
        There are no files to display.
      }
    </div>
  </div>
</div>
